import { action, createRequestTypes } from '../base';

export const qcPointActionTypes = {
  GET_QC_POINTS: createRequestTypes('GET_QC_POINTS'),
  GET_QC_POINT_BY_ID: createRequestTypes('GET_QC_POINT_BY_ID'),
  CREATE_QC_POINT: createRequestTypes('CREATE_QC_POINT'),
  UPDATE_QC_POINT: createRequestTypes('UPDATE_QC_POINT'),
  UPDATE_QC_POINT_PRODUCT: createRequestTypes('UPDATE_QC_POINT_PRODUCT'),
  DELETE_QC_POINT: createRequestTypes('DELETE_QC_POINT'),
  DELETE_QC_POINT_GROUP: createRequestTypes('DELETE_QC_POINT_GROUP'),
  GET_QC_POINT_BY_SKU_ID: createRequestTypes('GET_QC_POINT_BY_SKU_ID'),
  DOWNLOAD_QC_POINTS: createRequestTypes('DOWNLOAD_QC_POINTS'),
};

class QCPointActions {

  getQCPoints = (tenantId, groupId, operation, productSkuId, accessControl, departmentId, sellerId, category, page, limit, searchKeyword, defaultAssigneeId, controlPer, qcVerificationType) => action(qcPointActionTypes.GET_QC_POINTS.REQUEST, {
    tenantId, groupId, operation, productSkuId, accessControl, departmentId, sellerId, category, page, limit, searchKeyword, defaultAssigneeId, controlPer, qcVerificationType
  })


  getQCPointsLoading = (qualityControlPointsLoading) => action(qcPointActionTypes.GET_QC_POINTS.LOADING, {
    qualityControlPointsLoading,
  })

  getQCPointsSuccess = (qualityControlPoints) => action(qcPointActionTypes.GET_QC_POINTS.SUCCESS, {
    qualityControlPoints,
  })


  getQCPointById = (tenantId, groupId) => action(qcPointActionTypes.GET_QC_POINT_BY_ID.REQUEST, {
    tenantId, groupId,
  })


  getQCPointByIdLoading = (getQCPointByIdLoading) => action(qcPointActionTypes.GET_QC_POINT_BY_ID.LOADING, {
    getQCPointByIdLoading,
  })


  getQCPointByIdSuccess = (selectedQCPointById) => action(qcPointActionTypes.GET_QC_POINT_BY_ID.SUCCESS, {
    selectedQCPointById,
  })


  createQCPoint = (payload, callback) => action(qcPointActionTypes.CREATE_QC_POINT.REQUEST, {
    payload,
    callback,
  })


  createQCPointLoading = (createQCPointLoading) => action(qcPointActionTypes.CREATE_QC_POINT.LOADING, {
    createQCPointLoading,
  })


  updateQCPoint = (payload, callback) => action(qcPointActionTypes.UPDATE_QC_POINT.REQUEST, {
    payload,
    callback,
  })

  updateQCPointLoading = (updateQCPointLoading) => action(qcPointActionTypes.UPDATE_QC_POINT.LOADING, {
    updateQCPointLoading,
  })

  updateQCPointProduct = (payload, callback) => action(qcPointActionTypes.UPDATE_QC_POINT_PRODUCT.REQUEST, {
    payload,
    callback,
  })

  updateQCPointProductLoading = (updateQCPointProductLoading) => action(qcPointActionTypes.UPDATE_QC_POINT_PRODUCT.LOADING, {
    updateQCPointProductLoading,
  })

  deleteQCPoint = (payload, callback) => action(qcPointActionTypes.DELETE_QC_POINT.REQUEST, {
    payload,
    callback,
  })

  deleteQCPointLoading = (deleteQCPointLoading) => action(qcPointActionTypes.DELETE_QC_POINT.LOADING, {
    deleteQCPointLoading,
  })

  deleteQCPointGroup = (payload, callback) => action(qcPointActionTypes.DELETE_QC_POINT_GROUP.REQUEST, {
    payload,
    callback,
  })

  deleteQCPointGroupLoading = (deleteQCPointGroupLoading) => action(qcPointActionTypes.DELETE_QC_POINT_GROUP.LOADING, {
    deleteQCPointGroupLoading,
  })

  getQCPointBySkuId = (tenantId, productSkuId) => action(qcPointActionTypes.GET_QC_POINT_BY_SKU_ID.REQUEST, {
    tenantId, productSkuId,
  })

  getQCPointBySkuIdLoading = (getQCPointBySkuIdLoading) => action(qcPointActionTypes.GET_QC_POINT_BY_SKU_ID.LOADING, {
    getQCPointBySkuIdLoading,
  })

  getQCPointBySkuIdSuccess = (qcPointsBySkuId) => action(qcPointActionTypes.GET_QC_POINT_BY_SKU_ID.SUCCESS, {
    qcPointsBySkuId,
  })

  // get quality check points report

  getQCPointsReport = (tenantId, selectedEmails, userId, callback) => action(qcPointActionTypes.DOWNLOAD_QC_POINTS.REQUEST, {
    tenantId, selectedEmails, userId, callback,
  })

  getQCPointsReportLoading = (getQCPointsReportLoading) => action(qcPointActionTypes.DOWNLOAD_QC_POINTS.LOADING, {
    getQCPointsReportLoading,
  })
}

export default new QCPointActions();
